import ModalLayout from '../components/ModalLayout';
import { Button, Space } from 'antd';
import React from 'react';
import { useAuthMutation } from '../../../hooks/Auth';
import { auth } from '../../../auth/firebaseAuth';
import CenterLayout from '../../vendorlink-views/components/CenterLayout';
import ErrorMessage from '../../auth-views/components/ErrorMessage';
import PasswordForm, { PasswordFormValues } from '../../auth-views/components/PasswordForm';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';

interface VerifyPasswordStepProps {
  onNext: () => void;
  onCancel?: () => void;
  onForgotPassword: () => void;
}

const VerifyPasswordStep: React.FC<VerifyPasswordStepProps> = ({ onNext, onCancel, onForgotPassword }) => {
  const [user] = useAuthState(auth);
  const email = user?.email ?? undefined;
  const { control, handleSubmit } = useForm<PasswordFormValues>({});
  const { useReauthenticateWithCredential } = useAuthMutation();
  if (!email) {
    return <></>;
  }
  const onSubmit = async (values: PasswordFormValues) => {
    const authResult = await useReauthenticateWithCredential.mutateAsync(values.password);
    if (authResult.type === 'SUCCESS') {
      onNext();
    }
  };
  return (
    <CenterLayout>
      <ModalLayout
        header={
          <Space direction="vertical">
            <div className="heading-xs">Password required for access</div>
            <div className="text-content-secondary">
              The page you're trying to access contains important information. For your account security, re-enter your
              password to continue.
            </div>
          </Space>
        }
        content={
          <>
            <ErrorMessage />
            <PasswordForm control={control} onSubmit={handleSubmit(onSubmit)} />
          </>
        }
        footer={
          <>
            <Space>
              <Button
                disabled={useReauthenticateWithCredential.isLoading}
                onClick={handleSubmit(onSubmit)}
                type="primary"
              >
                Continue
              </Button>
              {onCancel && (
                <Button onClick={onCancel} type="text">
                  Cancel
                </Button>
              )}
            </Space>
            <Link to="#" onClick={onForgotPassword}>
              <b> I forgot my password</b>
            </Link>
          </>
        }
      />
    </CenterLayout>
  );
};

export default VerifyPasswordStep;
